import React from 'react';
// import {FilterVehicle} from '../transient/vehicle/FilterVehicle';
import { FilterAmenity } from '../../filter-bases';
import { useSelector } from 'react-redux';
import { SearchPageView } from 'utils/search-page-view';
import { FilterSpotSort } from '../transient/spot-sort';
export const FiltersAirport = () => {
    const view = useSelector((s) => s.search.data.view);
    return (<>
            <FilterSpotSort />
            <FilterAmenity amenity="shuttle">Airport Shuttle</FilterAmenity>
            <FilterAmenity amenity="self-park">Self Park</FilterAmenity>
            {view === SearchPageView.DESKTOP_LIST && (<FilterAmenity amenity="covered-parking">
                    Garage - Covered
                </FilterAmenity>)}
        </>);
};
